module.exports = __webpack_public_path__ + "img/icon-clients.9d79344d.svg";